var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "card-body" }, [
        _c(
          "div",
          { staticClass: "flex justify-content-between" },
          [
            _c(
              "div",
              [
                _vm.selectedDate
                  ? _c("DateSelect", {
                      ref: "selectedDate",
                      attrs: {
                        disabled: true,
                        onSelect: _vm.updateSelectedDate,
                        selectedDate: _vm.selectedDate,
                        dateRange: _vm.dateRange,
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c("LoadingButton", {
              attrs: {
                title: "Показать",
                type: "button",
                loading: _vm.loading,
                color: _vm.$constants.SUCCESS_COLOR,
                onClick: () => _vm.showReport(),
                className: "btn btn-outline-success",
              },
            }),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _vm.reportLoaded
      ? _c("div", { staticClass: "report_block" }, [
          _c("div", { class: { loading_block: true, active: _vm.loading } }),
          _vm._v(" "),
          _c("div", { staticClass: "card" }, [
            _c(
              "div",
              {
                staticClass:
                  "card-body flex justify-content-between flex_gap_10",
              },
              [
                !_vm.loading
                  ? _c(
                      "div",
                      [
                        _c("Saldo", {
                          ref: "saldo",
                          attrs: {
                            division: _vm.selectedDivision,
                            hideYesterday: true,
                            balance: _vm.balance,
                            expenses: _vm.expenses,
                            incomes: _vm.incomes,
                            exchanges: [],
                            orders: _vm.orders,
                          },
                        }),
                        _vm._v(" "),
                        _vm.ncAmount
                          ? _c("p", [
                              _vm._v(
                                "\n            ИТОГО без подтвержденных инкассаций: "
                              ),
                              _c("strong", [
                                _vm._v(
                                  _vm._s(
                                    (
                                      (_vm.balance?.dayOffSum ?? 0) -
                                      _vm.ncAmount
                                    ).toLocaleString("ru-RU")
                                  )
                                ),
                              ]),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.balance
                          ? _c("Calculation", {
                              ref: "balanceCalculation",
                              attrs: {
                                useCashOut: false,
                                balance: _vm.balance,
                                noCashOrders: [],
                                division: _vm.selectedDivision,
                                divisions: [],
                                dayData: _vm.reportData,
                                expenses: _vm.expenses,
                                incomes: _vm.incomes,
                                refreshReport: _vm.showReport,
                                exchanges: _vm.reportData.exchanges ?? [],
                                orders: [],
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _vm.ncAmount
                      ? _c("p", [
                          _c("strong", [
                            _vm._v("Инкассации без подтверждения"),
                          ]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("NonConfirmedIncomes", {
                      attrs: {
                        records: _vm.balance?.nonConfirmedIncomes,
                        hideReject: "true",
                        confirmStatus: "2",
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card" }, [
            _vm._m(1),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "card-body p-t-1" },
              [
                _c("ExpensesBlock", {
                  attrs: {
                    expenses: _vm.expenses,
                    types: _vm.expensesTypes,
                    division: _vm.selectedDivision,
                    currencies: _vm.allowedCurrencies,
                    userId: _vm.$currentUID,
                    users: {},
                    date: _vm.selectedDate,
                    notConfirmedExpenses: true,
                    updateExpenses: (r) => (_vm.expenses = r),
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          false && _vm.checkPermission("allowToBuyCurrency")
            ? _c("div", { staticClass: "card" }, [
                _vm._m(2),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "card-body p-t-1" },
                  [
                    _c("CurrencyExchangeBlock", {
                      attrs: {
                        records: _vm.exchanges,
                        disableToSaveRate: true,
                        currencies: _vm.allowedCurrencies,
                        date: _vm.selectedDate,
                        userId: _vm.$currentUID,
                        division: _vm.selectedDivision,
                        updateRecords: _vm.updateExchanges,
                      },
                    }),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "card" }, [
            _vm._m(3),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "card-body p-t-1" },
              [
                _c("IncomesBlock", {
                  ref: "IncomesBlock",
                  attrs: {
                    records: _vm.incomes,
                    date: _vm.selectedDate,
                    receivers: _vm.getAllowedReceivers(),
                    userReceivers: _vm.getAllowedReceivers(
                      "allowed_cashout_to_users"
                    ),
                    userId: _vm.$currentUID,
                    users: {},
                    useConfirm: true,
                    division: _vm.selectedDivision,
                    updateReport: () => _vm.showReport(null, null, true),
                  },
                }),
              ],
              1
            ),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h6", [_vm._v("Отчет за день")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h6", [_vm._v("Расходы")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h6", [_vm._v("Покупка валюты")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h6", [_vm._v("Инкассации")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }